import { coreReducers, lazyReducerImports, getAllReducers } from '../reducers';
import { createReducerManager, injectReducer } from './reducerManager';
import thunk from 'redux-thunk';
import { configureStore } from '@reduxjs/toolkit';

import { accountApi } from '../api/accountApi';
import { MAX_DEVTOOLS_STATE_SIZE, LARGE_DATA_PLACEHOLDER, PRODUCTION_ENVIRONMENT } from './constants';

const middleware = [thunk, accountApi.middleware];

export default function configureEzlogicStore(preloadedState) {
    const initialReducers = process.env.NODE_ENV === 'test' ? getAllReducers() : coreReducers;
    const reducerManager = createReducerManager(initialReducers);

    const store = configureStore({
        reducer: reducerManager.reduce,
        middleware: [...middleware],
        devTools: process.env.NODE_ENV !== PRODUCTION_ENVIRONMENT && {
            maxAge: 20,
            stateSanitizer: (state) => {
                const sanitizedState = { ...state };

                if (sanitizedState.main && sanitizedState.main.integrationList) {
                    const integrationListSize = JSON.stringify(sanitizedState.main.integrationList).length;

                    if (integrationListSize > MAX_DEVTOOLS_STATE_SIZE) {
                        sanitizedState.main = {
                            ...sanitizedState.main,
                            integrationList: LARGE_DATA_PLACEHOLDER,
                        };
                    }
                }

                return sanitizedState;
            },
        },
        preloadedState,
    });

    store.reducerManager = reducerManager;

    // Eagerly inject all lazy reducers so existing code that accesses
    // state.ezlos, state.plugins, etc. continues to work immediately.
    // This avoids breaking any selector/mapStateToProps that runs before
    // the feature page loads. The dynamic imports still enable webpack
    // code-splitting — reducers load as separate chunks but are injected
    // at app startup rather than on navigation.
    // In test env, all reducers are already included via getAllReducers().
    if (process.env.NODE_ENV !== 'test') {
        Promise.all(
            Object.entries(lazyReducerImports).map(([key, importFn]) =>
                importFn().then((reducer) => {
                    injectReducer(store, key, reducer);
                }),
            ),
        );
    }

    window.app = {};
    window.app.store = store;

    return store;
}

export const store = configureEzlogicStore();
export { injectReducer };
